import { SliceZone } from "@prismicio/react";
import { createClient } from "../../prismicio";
import { components } from "../../slices";
import { Meta } from "@/components";
import PostGrid from "@/slices/PostGrid";

const LearningCenter = ({ page, posts }) => {
	return (
		<>
			<Meta
				metaTitle={page?.data?.meta_title}
				metaDescription={page?.data?.meta_description}
				socialShareImage={page?.data?.meta_image?.url}
			/>
			<main>
				<SliceZone
					slices={page.data.slices}
					components={{
						...components,
						post_grid: (props) => <PostGrid {...props} posts={posts} />,
					}}
				/>
			</main>
		</>
	);
};

export default LearningCenter;

export async function getStaticProps({ previewData }) {
	const client = createClient({ previewData });
	const page = await client.getSingle("learning_center");
	const posts = await client.getAllByType("post");
	const nav = await client.getSingle("nav");
	const footer = await client.getSingle("footer");

	return {
		props: {
			nav,
			page,
			footer,
			posts,
		},
	};
}
